import Splide from '@splidejs/splide';
import { openTeamModal } from '../team/team-modal-helpers';
window.openTeamModal = openTeamModal

const titleEl = document.getElementById('squads-slider__title');
const prevLabel = document.getElementById('squads-slider__prev-text');
const nextLabel = document.getElementById('squads-slider__next-text');

/*
|--------------------------------------------------------------------------
| Configure the slider, setup the animation and mount
|--------------------------------------------------------------------------
*/
const squadsComponent = document.querySelector('.squads-slider');
const splideTrack = document.querySelector('.squads-slider__track');
const squadDetailsEls = document.querySelectorAll('.squads-slider__details');

const splideOptions = {
  type: 'loop',
  speed: 800,
  pagination: false,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  clones: 5,
  perPage: 6,
  gap: '0px',
  focus: 'center',
  breakpoints: {
		760: {
			perPage: 4,
		},
  }
}

const squadsSlider = new Splide( '.squads-slider', splideOptions);


/*
|--------------------------------------------------------------------------
| Setup events for navigation and dragging, this updates the title and details blocks
|--------------------------------------------------------------------------
*/

function updateSliderNav(activeSlide, prevSlide, nextSlide) {
  titleEl.innerHTML = activeSlide?.dataset?.title ?? 'Squads';
  prevLabel.innerHTML = prevSlide?.dataset?.title ?? 'Previous';
  nextLabel.innerHTML = nextSlide?.dataset?.title ?? 'Next';
}

function updateSliderDetails(activeSlide) {
  const targetId = activeSlide?.dataset?.target;
  const targetEl = document.getElementById(targetId);

  if( !targetEl ) {
    return;
  }

  Array.from(squadDetailsEls).forEach((el) => {
    if( el === targetEl ) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  })
}


// When we change slide, update the title and reveal details blocks
squadsSlider.on( 'move ready', (newIndex, prevIndex, destIndex) => {

  // Select all slides within the splide container
  const slides = squadsSlider.Components.Elements?.slides;

  // On ready, just start from the first item
  if( !newIndex ) {
    newIndex = 0;
  }

  const activeSlide = slides[newIndex];
  const prevSlide = slides[newIndex - 1] ?? slides[slides.length - 1];
  const nextSlide = slides[newIndex + 1] ?? slides[0];

  // Update title and next/prev buttons
  updateSliderNav(activeSlide, prevSlide, nextSlide);

  // Update title and next/prev buttons
  updateSliderDetails(activeSlide);
});

// Once mounted, hook up an animation that applies the opacity and transforms to each slide
squadsSlider.on( 'ready', () => {

  // Limit the requestAnimationFrame to 60fps
  const desiredFPS = 60;
  const interval = 1000 / desiredFPS;
  let lastTime = 0;

  function animate(currentTime) {
    requestAnimationFrame(animate);

    // Run on 60fps timeline

      applySlideTransforms();
    
  }

  // Start the animation
  animate();

  // Wait for the items to be positioned and then fade in the slider
  setTimeout(() => {
    squadsComponent.classList.remove('opacity-0');
  }, 200);
})

// Mount the slider
squadsSlider.mount();


/*
|--------------------------------------------------------------------------
| Some helper functions that let us modify percentage values
|--------------------------------------------------------------------------
*/

// Find a value between two other values (min and max) based on a percentage
function lerp(percent, min, max) {
  return min + percent * (max - min);
}

function easeInOutLerp(percent, min, max) {
  // Apply an ease-in-out easing function to the alpha value
  const easedAlpha = 0.5 - 0.5 * Math.cos(percent * Math.PI);
  // Use the eased alpha for linear interpolation
  return min + easedAlpha * (max - min);
}

function easeOutLerp(percent, min, max) {
  // Apply an ease-out easing function to the alpha value
  const easedAlpha = 1 - Math.pow(1 - percent, 2);
  // Use the eased alpha for linear interpolation
  return min + easedAlpha * (max - min);
}

function easeInLerp(percent, min, max) {
  // Apply an ease-in easing function to the alpha value
  const easedAlpha = Math.pow(percent, 2);
  // Use the eased alpha for linear interpolation
  return min + easedAlpha * (max - min);
}


/*
|--------------------------------------------------------------------------
| Run via requestAnimationFrame
| Calculates each slides' position in the slider and applies opacity/transforms based on their progress
|--------------------------------------------------------------------------
*/

function applySlideTransforms() {

  // Select all slides within the splide container
  const slides = splideTrack.querySelectorAll('.splide__slide');

  // Get the bounding rectangle of the splide container
  const splideRect = splideTrack.getBoundingClientRect();

  // Get the middle point of the splide container
  const splideMiddle = splideTrack.offsetWidth / 2;

  // We measure from the edge of each slide, so edge distance allows us to 
  const slideWidth = slides[0].offsetWidth/2;
  const edgeDistance = splideTrack.offsetWidth/2 + slideWidth * 2;

  // Loop through each slide
  slides.forEach(slide => {
    const inner = slide.querySelector('.splide_slide-inner');

    // Get the center point of each slide - this is the value we compare
    const slideRect = slide.getBoundingClientRect();
    const slideCenter = (splideRect.left * -1) + slideRect.left + (slide.offsetWidth / 2);

    // Calculate the horizontal distance from the center of the slide to the container
    const centerDistance = slideCenter - splideMiddle;
    const absCenterDistance = Math.abs(centerDistance);
    
    // Convert the distance from center to a percentage (center = 1, edge = 0)
    const progress = (1 - (absCenterDistance/edgeDistance)).toFixed(2);
    const absProgress = Math.abs(progress);

    // Grab the settings from our slide settings and set defaults if not provided
    const {  
      opacityMin = 0.25,
      scaleMinMax = [0.8, 1.5],
      translateMax = -2,
      blurMax = 3
    } = splideOptions;

    // We apply multiple transform properties, so push into array and join later
    let transformStyles = [];

    // TranslateX (works like kerning)
    if( translateMax ) {
      const translateMultiplier = easeOutLerp(progress, translateMax, 0);
      const translateValue = centerDistance > 0 ? (slideWidth * translateMultiplier) : (slideWidth * translateMultiplier) * -1;
      
      if( inner.querySelector('img') ) {
        inner.querySelector('img').style.transform = `translateX(${translateValue}px)`;
      }
    }
  
    // Scale
    if( scaleMinMax[0] && scaleMinMax[1] ) {
      const scaleMultiplier = lerp(progress, scaleMinMax[0], scaleMinMax[1])
      
      transformStyles.push(`scale(${scaleMultiplier})`);
    }

    // Opacity
    if( opacityMin ) {
      const opacityValue = easeInOutLerp(Math.max(progress,0), 0, 1);
      inner.querySelector('img').style.opacity = opacityValue;
    }

    // Blur
    if( blurMax ) {
      const blurValue =  lerp(progress, blurMax, 0);
      inner.style.filter = `blur(${blurValue }px)`;
    }

    // Z-index
    slide.style.zIndex = Math.round(progress * 100);

    // Apply any transform properties to the inner element
    inner.style.transform = transformStyles.join(" ");

    // Apply as a data attribute for debugging
    slide.dataset.progress = `${progress}`;

  });
}


/*
|--------------------------------------------------------------------------
| On click, scroll to the clicked slide
|--------------------------------------------------------------------------
*/
squadsComponent.addEventListener('click', (e) => {
  const target = e.target;

  // Check if this was a click inside a slide
  const splideSlide = e.target.closest('.splide__slide');

  if ( !splideSlide ) {
    return;
  }

  // Find the index of the clicked slide and go to it
  const slides = squadsSlider.Components.Slides.get();
  const targetSlide = slides.find(item => item.slide === splideSlide);

  if( targetSlide ) {
    squadsSlider.go(targetSlide.index);
  }
})
